import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isGetAndroidNotificationChannelsResult = objectOf({
  channels: arrayOf(
    objectOf({
      id: string,
      channel_id: string,
      name: string,
    })
  ),
  fallback_channel_id: string,
});

export const isUpdateAndroidNotificationChannelsResult = arrayOf(
  objectOf({
    id: string,
    channel_id: string,
    name: string,
  })
);
